const spacing = {
  xxs: "2px",
  xs: "4px",
  s: "8px",
  m: "16px",
  xm: "24px",
  l: "32px",
  xl: "40px",
  xxl: "48px",
};

export default spacing;
